"use strict";
//@ts-nocheck
/**
 * Javascript class for gs1_seminars extension.
 * Based on the jQuery framework.
 */
var Seminars = {
    // Uri for eID script
    ajaxUri: '?eID=tx_gs1seminars_fe_eidtools',
    // Storage for filter values
    filterValues: {},
    // Selector string for the list plugin
    selectorList: '.tx-gs1seminars-pi-list',
    // Selector string for the detail plugin
    selectorDetail: '.tx-gs1seminars-pi-detail',
    classTab: 'seminar-tab',
    // Class for tab content in detail view
    classTabContent: 'seminar-content',
    // Class for participants price selection
    classParticipantItem: 'participant-item',
    // Percent number for calculating the purchase tax
    percentPurchaseTax: 19,
    // Id of the element for the participants list
    idParticipantsWrap: '#participants',
    // Class for wrapper element of a single participant
    classParticipantWrap: '.participant',
    // Class for title element of a single participant
    classParticipantsTitle: '.participant-title',
    // Class for title element of a single (additional) participant
    classAdditionalParticipantsTitle: '.additional-participant-title',
    // Id of the dummy element for first participants selection
    idFirstParticipantsDummy: '#first-participant-dummy',
    // Id of the dummy element for following participants selection
    idFollowingParticipantsDummy: '#following-participant-dummy',
    // Id of the container element for additional participants data
    idContainerParticipantsDataDummy: '#additional-participants',
    // Id of the dummy element for entering participants data
    idParticipantsDataDummy: '#participant-data-dummy',
    // Id of the container element for form summary
    idContainerSummary: '#participant_summary',
    // Object for form data (json encoded)
    formData: {},
    // Flag if user may access the protected tab
    hasAccess: false,
    /**
     * Initiate the seminars class.
     */
    init: function () {
        // Initiate detail view
        if ($(Seminars.selectorDetail).length > 0) {
            if (window.location.hash) {
                var fragment = window.location.hash.replace('#', '');
                var redirectUrl = $(Seminars.selectorDetail).find('ul.tabs').find('a:contains(' + fragment + ')').attr('href');
                if (redirectUrl) {
                    txGs1Base.activityIndicator.attach();
                    window.location = redirectUrl;
                }
            }
            Seminars.initPaymentRadios();
            Seminars.initTaxRate();
            Seminars.initRegistrationForm();
            Seminars.initProgrammSelection();
            Seminars.initFileProtection();
            Seminars.initTeamtickets();
        }
        // Add fancybox for selection of seminar dates
        Seminars.handleTabNavigation();
    },
    initTeamtickets: function () {
        $('[data-num-participants]').each(function (index, element) {
            if ($(element).data('num-participants') > 1) {
                $(element).on('change', function () {
                    // Select the number of participants
                    $('#num_participants').val($(element).data('num-participants')).change();
                    Seminars.initTeamtickets();
                    Seminars.selectTeamticketPrices($(element).data('num-participants'));
                });
            }
        });
    },
    selectTeamticketPrices: function (numParticipants) {
        $('[data-num-participants]').each(function (index, element) {
            // Skip the markup dummy element, so the form values for the participants do not get overridden on submit!
            if ($(element).attr('name') != 'tx_gs1seminars_registration[participant_payment]') {
                if ($(element).data('num-participants') == numParticipants) {
                    Seminars.selectPayment(this);
                }
            }
        });
        // Hide all other price options for all except the first participant and the dummy row
        $('.participant-row').each(function (index, element) {
            if (index > 0 && $(element).attr('id') != 'following-participant-dummy') {
                $(element).find('.payment-row:not(.teamticket-' + numParticipants + ')').hide();
            }
        });
    },
    showHiddenPrices: function (element) {
        // Show all prices that may have been hidden previously
        $('.payment-row').show();
    },
    initPaymentRadios: function () {
        $('[name*=participant_payment]').on('change', function () {
            Seminars.selectPayment(this);
            if ($(this).data('num-participants') == 1) {
                Seminars.showHiddenPrices();
            }
        });
    },
    /**
     * Override the default tax rate with the value defined in page wide var
     * currentStandardTaxRate (set via TypoScript lib object in in Formhandler)
     */
    initTaxRate: function () {
        if (typeof currentStandardTaxRate !== 'undefined') {
            if (currentStandardTaxRate > 0) {
                Seminars.percentPurchaseTax = currentStandardTaxRate;
            }
        }
    },
    /**
     * Override default tab behaviour in seminar list view
     */
    handleTabNavigation: function () {
        $('.tx-gs1seminars-pi-list .tab-item a').on('click', function (e) {
            e.preventDefault();
            var href = $(this).attr('href');
            if (href) {
                window.location.href = href;
            }
        });
    },
    /**
     * Initialize the registration form for this seminar.
     * Bin event listeners to select boxes.
     */
    initRegistrationForm: function () {
        // Add event listener to selectbox
        $('#num_participants').on({
            'change': function () {
                Seminars.selectNumberOfParticipants(this);
                Seminars.initPaymentRadios();
                Seminars.initTeamtickets();
                Seminars.showHiddenPrices();
            }
        });
        $('.special-event select').on({
            change: function () {
                Seminars.selectNumberOfParticipantsForSpecialEvent(this);
            }
        });
        $('#seminar_date').on({
            'change': function () {
                Seminars.showSeminarDateSelection(this);
            }
        });
        Seminars.selectNumberOfParticipants($('#num_participants'));
        Seminars.selectNumberOfParticipantsForSpecialEvent($('.special-event select'));
        Seminars.setDefaultValueForPriceSelection();
        // Check if there are values. If so, set flag to display form
        var hideBillingAddress = true;
        var billingAddressForm = $('#billing-address');
        billingAddressForm.find('input,select').each(function (index, element) {
            var value = $(element).val();
            if (element.tagName == 'INPUT' && value != '') {
                hideBillingAddress = false;
                // Exit each()
                return false;
            }
            if (element.tagName == 'SELECT' && parseInt(value) != 276) {
                hideBillingAddress = false;
                // Exit each()
                return false;
            }
        });
        if (hideBillingAddress == true) {
            billingAddressForm.hide();
        }
        else {
            billingAddressForm.show();
        }
        let country = $('#country');
        let taxId = $('.field-wrap-tax_id').hide();
        country.on('change', function () {
            if (country.val() !== 'Deutschland') {
                taxId.show();
            }
            else {
                taxId.hide();
            }
        });
    },
    /**
     * Detect if participants have to be added or removed.
     * When adding, clone dummy element, change id and name attributes and add it to list.
     * When removing, call function to update price info.
     *
     * @param element The calling element
     */
    selectNumberOfParticipants: function (element) {
        var numParticipants = $(element).find(':selected').val();
        var existingParticipants = $(Seminars.idParticipantsWrap + ' ' + Seminars.classParticipantWrap);
        var numExistingParticipants = existingParticipants.length;
        // Reduce the number of participants for special events to the number of participants
        Seminars.manipulateSpecialEventsSelectorBox(numParticipants);
        if (numParticipants > numExistingParticipants) {
            // Add participants
            for (var i = numExistingParticipants; i < numParticipants; i++) {
                if (i == 0) {
                    // Clone dummy element for first participant
                    var newParticipant = $(Seminars.idFirstParticipantsDummy).clone();
                }
                else {
                    // Clone dummy element for following participant
                    var newParticipant = $(Seminars.idFollowingParticipantsDummy).clone();
                }
                // Remove id
                newParticipant.attr('id', '');
                // Add class
                newParticipant.addClass(Seminars.classParticipantItem);
                // Add number to title
                var title = newParticipant.find(Seminars.classParticipantsTitle);
                title.text(title.text() + ' ' + (i + 1));
                // Todo: Find a way to prevent dummy from being sent
                // e.g. when user uses form-autofill function from webdeveloper tools - is this relevant?
                // Update name, id and for-attributes for radio buttons and labels
                newParticipant.find('input[type=radio]').each(function (index, element) {
                    var elementId = $(element).attr('id');
                    var elementName = $(element).attr('name');
                    $(element).attr('id', elementId + '-' + i);
                    $(element).parent('label').attr('for', elementId + '-' + i);
                    $(element).attr('name', elementName + '[' + i + '][]');
                });
                newParticipant.show().appendTo(Seminars.idParticipantsWrap);
            }
            Seminars.setDefaultValueForPriceSelection();
        }
        else if (numParticipants < numExistingParticipants) {
            // Remove participants
            existingParticipants.filter(':eq(' + numParticipants + '),:gt(' + numParticipants + ')').remove();
            // Update price calculation for special events
            Seminars.selectNumberOfParticipantsForSpecialEvent($('.special-event select'));
            Seminars.setDefaultValueForPriceSelection();
            Seminars.updatePriceInfo();
        }
    },
    /**
     * Limit selectable options to the number of participants.
     *
     * @param integer Number of regular participants for this seminar.
     */
    manipulateSpecialEventsSelectorBox: function (numberOfParticipants) {
        $('.special-event').each(function (index, element) {
            var select = $(element).find('select.special-events');
            var options = '';
            var selectedValue = $(':selected', select).val();
            for (var i = 0; i <= numberOfParticipants; i++) {
                options += '<option value="' + i + '"';
                if (selectedValue > 0 && i == selectedValue) {
                    options += ' selected="selected"';
                }
                options += '>' + i + '</option>';
            }
            select.find('option').remove();
            select.append(options);
            // Trigger chosen update
            select.trigger('chosen:updated');
        });
    },
    /**
     * Get price and label for the selected payment.
     * Add label and price to rows title.
     *
     * @param element The calling element
     */
    selectPayment: function (element) {
        $(element).prop('checked', true);
        var paymentTitle = $(element).parent('label').find('.payment-title').text();
        var costs = parseFloat($(element).parents('.payment-row').find('.payment-price').text());
        $(element).parents(Seminars.classParticipantWrap).find('.price-title').text(paymentTitle + ': ');
        $(element).parents(Seminars.classParticipantWrap).find('.price').text(costs.toFixed(2) + ' €');
        Seminars.updatePriceInfo();
    },
    /**
     * Get the selected number of participants for a special event.
     * Calculate the price and update price infos.
     *
     * @param element The calling element
     */
    selectNumberOfParticipantsForSpecialEvent: function (elements) {
        var valuesChanged = false;
        $(elements).each(function () {
            var elementObj = $(this);
            var $parentObj = elementObj.closest('.special-row');
            var $priceObj = jQuery('input.price-value', $parentObj);
            var price = $priceObj.val();
            if (parseFloat(price) > 0.00) {
                var numParticipantsSpecialEvent = parseInt(elementObj.find(':selected').val());
                var costs = parseFloat(numParticipantsSpecialEvent * price);
                jQuery('.price', $parentObj).text(costs.toFixed(2) + ' €');
                valuesChanged = true;
            }
        });
        if (valuesChanged == true) {
            Seminars.updatePriceInfo();
        }
    },
    /**
     * Get all prices for regular participants and participants for special events.
     * Add the prices, calculate the purchase tax and show the results.
     */
    updatePriceInfo: function () {
        var recipientPrices = 0;
        var specialEventPrices = 0;
        var subtotal = 0;
        var purchaseTax = 0;
        var total = 0;
        // Wait a short while to get all prices correctly, see issue #8438
        window.setTimeout(function () {
            $('.participant').find('.price').each(function (index, element) {
                recipientPrices += parseFloat($(element).text());
            });
            $('.special-events-wrapper').find('.price').each(function (index, element) {
                specialEventPrices += parseFloat($(element).text());
            });
            subtotal = parseFloat(recipientPrices + specialEventPrices);
            purchaseTax = parseFloat((subtotal / 100) * Seminars.percentPurchaseTax);
            total = parseFloat(subtotal + purchaseTax);
            $('#subtotal').text(Seminars.convertToCommaFloat(subtotal.toFixed(2)) + ' €');
            $('#purchase_tax').text(Seminars.convertToCommaFloat(purchaseTax.toFixed(2)) + ' €');
            $('.current_tax_rate').text(Seminars.convertToCommaFloat(Seminars.percentPurchaseTax));
            $('#total').text(Seminars.convertToCommaFloat(total.toFixed(2)) + ' €');
            Seminars.toggleIsCostFree(total);
        }, 300);
    },
    /**
     * Toggle the value of hidden input isCostFree and manipulate
     * elements in order progress indicator according to isCostFree status
     *
     * @param total
     */
    toggleIsCostFree: function (total) {
        if (total === 0) {
            $('#isCostFree').val(1);
            $('#order-progress-3').hide(100);
            $('#order-progress-4 .step-numerator').text('3');
        }
        else {
            $('#isCostFree').val(0);
            $('#order-progress-3').show(100);
            $('#order-progress-4 .step-numerator').text('4');
        }
    },
    /**
     * Create menu for dates in program tab to show the related contents.
     */
    initProgrammSelection: function () {
        var programmDays = {};
        var dateContentExists = false;
        var dateContentSelector = '.programm > div[class!="change-date"][class!="programm-0"]';
        $(dateContentSelector).each(function (index, element) {
            programmDays[$(element).attr('class')] = 1;
            // Set flag that there is content
            dateContentExists = true;
        });
        if (dateContentExists == true) {
            var programmLinks = '<div class="change-date"><span class="programm-tabs-label">Alle Tage:</span><ul class="programm-tabs nav nav-pills nav-pills-minor">';
            // Create date menu from all dates
            jQuery.each(programmDays, function (key, value) {
                var timestamp = key.split('-')[1];
                if (timestamp > 0) {
                    var date = new Date(timestamp * 1000);
                    var month = String(date.getMonth() + 1);
                    if (month.length == 1) {
                        month = '0' + month;
                    }
                    var dateString = date.getDate() + '.' + month + '.' + date.getFullYear();
                    programmLinks += '<li><a href="' + key + '">' + dateString + '</a></li>';
                    $('.' + key).hide();
                }
            });
            programmLinks += '</ul></div>';
            $(programmLinks).insertBefore($('.programm')).find('a').on({
                click: function () {
                    // Store clicked link
                    var link = $(this);
                    // Hide all contents
                    $(dateContentSelector).hide();
                    // Show date selector menu (for IE)
                    $('.change-date').show();
                    // Remove active class from all links
                    $('.programm-tabs li').removeClass('active');
                    // Add active class to clicked link
                    link.parent('li').addClass('active');
                    // Show matching content blocks
                    $('.' + link.attr('href')).show();
                    // Return false to prevent reload
                    return false;
                }
            });
            // Make first date and contents visible
            $('.programm-tabs li:first').addClass('active');
            $('.' + $('.programm-tabs li:first A').attr('href')).show();
        }
    },
    /**
     * Show error messages in lightbox.
     *
     * @param string messages The messages to display
     */
    displayErrorMessages: function (messages) {
        Seminars.openNewLightboxWithContent(messages, function () {
        });
    },
    showSeminarDateSelection: function (selectObj) {
        var selectedValue = jQuery(selectObj).val();
        var selectedUrlDesc = jQuery('#seminar_date_url_' + selectedValue + '-programm').val();
        var selectedUrlBook = jQuery('#seminar_date_url_' + selectedValue).val();
        var defaultValue = jQuery('#default_seminar_date').val();
        var defaultUrl = jQuery('#seminar_date_url_' + defaultValue).val();
        if (selectedValue == defaultValue) {
            return;
        }
        var message = '<div id="lightbox_pagetype">' +
            '<h4 class="h1">Termin bestätigen</h4>' +
            '<div>Sie haben einen alternativen Termin für diese Veranstaltung gewählt.<br />' +
            'Bitte beachten Sie, dass die Inhalte und Referenten von den Angaben im ursprünglichen Termin abweichen können.<br />' +
            'Klicken Sie <a href="' + selectedUrlDesc + '">hier</a>, um sich über den Termin zu informieren.<br /><br />' +
            'Bitte bestätigen Sie Ihre Auswahl mit OK oder klicken Sie auf Abbrechen um zur ursprünglichen Auswahl zurückzukehren.</div>' +
            '<div class="form-bottom-navigation">' +
            '	<button class="btn btn--blue pull-left" value="Abbrechen" onclick="parent.jQuery.fancybox.close();">' +
            '		<span class="btntxt">Abbrechen</span>' +
            '		<span aria-hidden="true" class="icon-arrow_left"></span>' +
            '	</button>' +
            '	<form action="' + selectedUrlBook + '" method="post">' +
            '		<button class="btn pull-right" value="OK">' +
            '			<span class="text">OK</span>' +
            '			<span aria-hidden="true" class="icon-arrow_right"></span>' +
            '		</button>' +
            '	</form>' +
            '</div>' +
            '</div>';
        Seminars.openAlternateNewLightboxWithContent(message, function () {
        }, function () {
            Seminars.resetSeminarDateSelection();
        });
    },
    resetSeminarDateSelection: function () {
        var dateSelector = jQuery('#seminar_date');
        var oldIndex = 0;
        var i = 0;
        jQuery(dateSelector).find('option').each(function () {
            if (jQuery(this).attr('id') === 'default_seminar_date') {
                oldIndex = i;
            }
            i++;
        });
        dateSelector.find('option:selected').prop('selected', false);
        dateSelector.prop('selectedIndex', oldIndex);
        jQuery('#default_seminar_date').prop('selected', 'selected');
        dateSelector.trigger('chosen:updated');
        var dateText = jQuery('#default_seminar_date').text();
        dateSelector.next().find('.mw-selected-value').text(dateText);
    },
    /**
     * Toogle the fieldset for emailForBillingShipment based on country
     * @param countryId
     */
    toggleEmailForBillingShipmentFieldset: function (countryId) {
        if (countryId > 0) {
            if (countryId == '276') {
                $('#fs_emailForBillingShipment').show();
            }
            else {
                $('#fs_emailForBillingShipment').hide();
            }
        }
    },
    /**
     * Take dummy element for additional participants, change required data and add it to form.
     * Init accordeon.
     *
     * @param integer numParticipants The number of participants to add
     */
    loadFormForAdditionalParticipants: function (numParticipants) {
        numParticipants -= 1;
        if (numParticipants > 0) {
            var existingParticipants = $(Seminars.idContainerParticipantsDataDummy + ' .participant');
            var numExistingParticipants = existingParticipants.length;
            if (numParticipants > numExistingParticipants) {
                for (var i = numExistingParticipants; i < numParticipants; i++) {
                    // Clone dummy element
                    var newAdditionalParticipant = $(Seminars.idParticipantsDataDummy).clone();
                    // Remove id
                    newAdditionalParticipant.attr('id', '');
                    // Add number to title
                    var title = newAdditionalParticipant.find(Seminars.classAdditionalParticipantsTitle);
                    title.text(title.text().replace(/x\./, (i + 2) + '.'));
                    // Update name-attributes for input fields
                    newAdditionalParticipant.find('input').each(function (index, element) {
                        var elementName = $(element).attr('name');
                        $(element).attr('name', elementName.replace(/\[participant\]/, '[participant][' + (i + 2) + ']'));
                    });
                    // Update id and for-attributes for radio buttons and labels
                    newAdditionalParticipant.find('input[type=radio]').each(function (index, element) {
                        var elementId = $(element).attr('id');
                        $(element).attr('id', elementId + '-' + i);
                        $(element).parent('label').attr('for', elementId + '-' + i);
                    });
                    newAdditionalParticipant.show().appendTo(Seminars.idContainerParticipantsDataDummy);
                }
            }
            else if (numParticipants < numExistingParticipants) {
                // Remove participants
                existingParticipants.filter(':eq(' + numParticipants + '),:gt(' + numParticipants + ')').remove();
            }
            // Init accordeon
            //$(Seminars.idContainerParticipantsDataDummy).mwaccordion();
        }
        else {
            // Clear container
            $(Seminars.idContainerParticipantsDataDummy).html('');
        }
    },
    /**
     * Convert incoming float value to a string an replace the dot by comma
     *
     * @param  float floatValue, The value to convert
     * @return string The float value with comma instead of dot
     */
    convertToCommaFloat: function (floatValue) {
        return floatValue.toString().replace(/,/, '.');
    },
    /**
     * Make links available only after correct password was submitted.
     * TODO Massive refactoring if real protection is required
     */
    initFileProtection: function () {
        var tabParticipantsData = $('#participants-data');
        if (tabParticipantsData.length > 0) {
            $('.csc-uploads a').each(function (index, element) {
                var link = $(element);
                // Store href for link
                var href = link.attr('href');
                // Remove href in link tag
                link.attr('href', '#');
                link.on('click', function (event) {
                    event.preventDefault();
                    if (Seminars.hasAccess === false) {
                        Seminars.openNewLightboxWithContent($('#prompt').html(), function () {
                            var fancybox = this;
                            $('.fancybox-inner input[name="tx_gs1seminars_registration[pass]"]').focus();
                            $('.fancybox-inner button').on({
                                click: function (event) {
                                    event.preventDefault();
                                    var seminarId = 0;
                                    if (typeof seminar_id != 'undefined') {
                                        if (parseInt(seminar_id) > 0) {
                                            seminarId = seminar_id;
                                        }
                                    }
                                    else {
                                        seminarId = $('input[name="tx_gs1seminars_registration[seminar_id]"]').val();
                                    }
                                    // Test password
                                    $.ajax({
                                        url: Seminars.ajaxUri,
                                        type: 'POST',
                                        data: {
                                            'action': 'validatePass',
                                            'pass': $('.fancybox-inner input[name="tx_gs1seminars_registration[pass]"]').val(),
                                            'seminar': seminarId
                                        },
                                        cache: false,
                                        complete: function (response) {
                                            var json = $.parseJSON(response.responseText);
                                            if (json.status) {
                                                if (json.status.message == 'true') {
                                                    // Set flag that password was correct
                                                    Seminars.hasAccess = true;
                                                    // Close overlay
                                                    $.fancybox.close();
                                                    // Open URL
                                                    window.open('/' + href, '_blank');
                                                    // Check if gallery is present
                                                    if (jQuery('.tx-gs1gallery-pi-gallery .galleryLayerInvisible .galleryImage').length > 0) {
                                                        unProtectGalleryImages();
                                                    }
                                                    if (jQuery('.tx-gs1downloads-pi-downloads .fileDownloadsInvisible').length > 0) {
                                                        unProtectDownloadFiles();
                                                    }
                                                }
                                                else if (json.status.message == 'false') {
                                                    // ToDo: Show error message
                                                }
                                            }
                                        }
                                    });
                                    return false;
                                }
                            });
                        });
                    }
                    else {
                        window.open('/' + href, '_blank');
                    }
                    return false;
                });
            });
        }
    },
    /**
     * Set default checked value for prices.
     * If there is a price for early registration, that one will be checked.
     * Otherwise the first price is checked by default.
     */
    setDefaultValueForPriceSelection: function () {
        $('.' + Seminars.classParticipantItem).each(function (index, element) {
            var $firstEarlyPriceElement = $(element).find('input[type=radio][disabled!=disabled].early-price:first');
            if ($firstEarlyPriceElement.length > 0) {
                $firstEarlyPriceElement.prop('checked', true);
                // Fix for #8402: Preisberechnung
                Seminars.selectPayment($firstEarlyPriceElement);
            }
            else {
                var $firstElementRegularPrice = $(element).find('input[type=radio][disabled!=disabled]:first');
                $firstElementRegularPrice.prop('checked', true);
                // Fix for #8402: Preisberechnung
                Seminars.selectPayment($firstElementRegularPrice);
            }
        });
    },
    /**
     * Opens new lightbox with content given in param
     * Has callback function param for further action (rebinding etc.)
     *
     * @param content
     * @param callbackFnc
     */
    openNewLightboxWithContent: function (content, callbackFnc) {
        Seminars.openAlternateNewLightboxWithContent(content, callbackFnc, function () { });
    },
    /**
     * Opens new lightbox with content given in param
     * Has callback function param for further action (rebinding etc.)
     *
     * @param content
     * @param callbackFnc
     * @param callbackFnc2
     */
    openAlternateNewLightboxWithContent: function (content, callbackFnc, callbackFnc2) {
        $.fancybox({
            content: content,
            onStart: function () {
            },
            beforeShow: function (current, previous) {
                //  callback function
                if (typeof callbackFnc == 'function') {
                    callbackFnc.call(this);
                }
            },
            afterClose: function () {
                //  callback function
                if (typeof callbackFnc2 == 'function') {
                    callbackFnc2.call(this);
                }
            },
            margin: 0,
            padding: 50,
            openMethod: 'modalIn',
            tpl: {
                wrap: '<div class="fancybox-wrap" id="fancybox" tabIndex="-1"><div class="fancybox-skin modal-dialog"><div class="fancybox-outer modal-content"><div class="fancybox-inner modal-body"></div></div></div></div>',
                closeBtn: '<button class="fancybox-item fancybox-close close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>'
            },
            helpers: {
                title: {
                    type: 'inside',
                    position: 'bottom'
                },
                overlay: {
                    locked: false
                }
            },
            afterLoad: function () {
                if ($(this.element).next('figcaption').length > 0) {
                    this.title = $(this.element).next('figcaption').html();
                }
                else {
                    this.title = "";
                }
            },
            afterShow: function () {
                if (this.title !== "") {
                    $('.modal-dialog').addClass('has-title');
                }
                $('.modal-dialog').animate({
                    top: 0,
                    opacity: 1
                }, 500);
            }
        });
    },
};
// Wait until DOM is ready
$(document).ready(function () {
    // Initiate the seminars class
    new Seminars.init();
});
